import {useEffect, useState} from 'react';

export default function useInitialLoading(time = 1) {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false);
    }, time * 1000);
  }, [setInitialLoading, time]);

  return {initialLoading};
}
